/*
  ThemeProvider.jsx
*/

// Npm.
import React, { useMemo } from 'react';

// Lib.
import getTheme from '../../utils/getTheme';

// Contexts.
import ThemeContext from '../../contexts/ThemeContext';

/**
 * Provides the theme.
 */
export default function ThemeProvider({ children, isDark = false }) {
  
  const theme = useMemo(() => getTheme(isDark), [isDark]);

  return (
    <ThemeContext.Provider value={theme}>
      { children }
    </ThemeContext.Provider>
  );
}
